module.exports = __webpack_public_path__ + "static/media/buy-red-extra.007a2a63.png";